import { ReactNode } from "react";
import { Info } from "lucide-react";

import { clsxMerge } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { Tooltip, TooltipContent, TooltipTrigger } from "shared/ui";

interface ProspectTagPropsI extends PropsWithClassNameI {
  tag: string;
  tooltip?: ReactNode;
}

export const ProspectTag = ({ tag, tooltip, className }: ProspectTagPropsI) => {
  if (!tag) {
    return null;
  }

  const tagContent = (
    <div
      className={clsxMerge(
        "bg-[#DFDFDF] px-2.5 py-1 text-[#666]",
        "flex gap-2 rounded text-center typography-body-4-bold",
        className
      )}
    >
      {tag}
      {tooltip && <Info size={16} />}
    </div>
  );

  return tooltip ? (
    <Tooltip>
      <TooltipTrigger>{tagContent}</TooltipTrigger>
      <TooltipContent className="z-50 max-w-[300px]">{tooltip}</TooltipContent>
    </Tooltip>
  ) : (
    tagContent
  );
};
